<template>
    <div class="quotes">
        <div class="controls">
            <a @click="previous" class="previous">
                <span class="fa fa-angle-left fa-fw"></span>
            </a>

            <a @click="next" class="next">
                <span class="fa fa-angle-right fa-fw"></span>
            </a>
        </div>

        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-7 col-md-9 col-sm-12 col-xs-12">
                    <div class="quote">
                        <div class="wrapper">
                            <div class="media">
                                <img class="d-flex align-self-start mr-3 author" :src="quote.image" alt="Generic placeholder image">

                                <div class="media-body">
                                    <div>
                                        <div class="name">{{quote.author}}</div>
                                        <span class="employment">{{quote.employment}}</span>
                                    </div>
                                </div>
                            </div>

                            <p class="description">
                                "{{quote.description}}"
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @import '~bootstrap/scss/bootstrap.scss';

    .quotes {
        position: relative;
        width: 100%;
        padding: 15vh 0;
        background-color: #36434d;
        background-image: url('/static/images/bgX.png');
        background-size: 300px auto;

        .controls {
            position: absolute;
            width: 100%;
            top: 50%;
            margin-top: -40px;

            a {
                cursor: pointer;
                position: absolute;
                color: #fff;
                font-size: 70px;
                text-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);

                &.previous {
                    left: 5vw;
                }

                &.next {
                    right: 5vw;
                }
            }
        }

        @include media-breakpoint-down(md) {
            padding: 50px 0;
        }

        .quote {
            padding: 30px;
            border-radius: 20px;
            background-color: #fff;
            box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);

            -webkit-touch-callout: none;
            -webkit-user-select: none;
            -khtml-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;

            .wrapper {
                position: relative;
                z-index: 1;
                padding-bottom: 50px;

                &:after {
                    position: absolute;
                    opacity: 0.45;
                    content: " ";
                    width: 100%;
                    height: 100%;
                    top: 0;
                    z-index: 0;
                    background-image: url('/static/images/quotes.png');
                    background-position: right bottom;
                    background-repeat: no-repeat;
                    background-size: 90px auto;
                }

                .media-body {
                    display: flex;
                    height: 100px;
                    align-items: center;
                    padding-left: 15px;
                }

                .author {
                    width: 100px;
                }

                .name {
                    font-weight: 200;
                    font-size: 23px;
                }

                .employment {
                    font-weight: 200;
                    font-size: 18px;
                }

                .description {
                    font-size: 20px;
                    font-weight: 200;
                    padding-top: 30px;
                }
            }
        }
    }
</style>

<script>
    export default {
        data() {
            return {
                show: 1,

                quotes: [
                    {
                        image: '/static/images/quotes/nisjensen.png',
                        author: 'Nis Jensen',
                        employment: 'Digital Marketingschef hos Admiral Hotel',
                        description: 'OPN er blevet et redskab, vi bruger på lige fod med andre værktøjer i vores marketingafdeling til overblik og optimering af indsatser og processer'
                    },
                    {
                        image: '/static/images/quotes/nielsfuglsang.png',
                        author: 'Niels Fuglsang',
                        employment: 'Advokat hos Sønderby Legal',
                        description: 'I en travl hverdag har det været rart, at vi på kort tid kan følge med i om vores hjemmeside og markedsføring skaber resultater. Også når vi er på farten!'
                    },
                    {
                        image: '/static/images/quotes/idasalomonsson.png',
                        author: 'Ida Oxenvad',
                        employment: 'Indehaver af Københavns Kropterapeut',
                        description: 'Ofte synes jeg, at det kan være svært at bruge og forstå de grafer, der vises i et redskab til marketing. Men OPN var simpelt og overskueligt. Jeg kunne rent faktisk nemt se, hvor jeg kunne blive bedre'
                    }
                ]
            }
        },

        computed: {
            total() {
                return this.quotes.length
            },

            quote() {
                return this.quotes[(this.show - 1)]
            }
        },

        methods: {
            next() {
                if (this.show ===  this.total) {
                    this.show = 1

                    return
                }

                this.show++
            },

            previous() {
                if (this.show === 1) {
                    this.show = this.total

                    return
                }

                this.show--
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Quotes.vue